<template>
  <div class="phone-view">
    <PhoneViewDisplay :jsonCode="jsonCode" />
    <PhoneViewJson :jsonCode="jsonCode" />
  </div>
</template>

<script>
  import PhoneViewDisplay from './PhoneViewDisplay.vue';
  import PhoneViewJson from './PhoneViewJson.vue';

  export default {
    components: {
      PhoneViewJson,
      PhoneViewDisplay
    },
    props: {
      jsonCode: Object
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PhoneView/PhoneView.vue